import axios from 'axios';

import { OrganizationalUnitDistribution } from 'components/types';

import { ORGANIZATIONAL_UNIT_DISTRIBUTIONS } from 'RestAPIs/endpoints';

export const getOrganizationalUnitDistributions = (employmentId: number) =>
  axios.get<OrganizationalUnitDistribution[]>(
    ORGANIZATIONAL_UNIT_DISTRIBUTIONS,
    {
      pathParams: { employmentId }
    }
  );

type SharedOrganizationalUnitRequest = {
  organizationalUnitId: number;
  percentage: number;
};

type OrganizationalUnitDistributionRequest = {
  employmentId: number;
  data: {
    startDate: string;
    endDate?: string;
    sharedOrganizationalUnits: SharedOrganizationalUnitRequest[];
  };
};

export const createOrganizationalUnitDistribution = ({
  employmentId,
  data
}: OrganizationalUnitDistributionRequest) =>
  axios.post(ORGANIZATIONAL_UNIT_DISTRIBUTIONS, data, {
    pathParams: { employmentId }
  });
